import { lazyRouteComponent } from "@tanstack/react-router"

export function lazyImportRouteComponent<T>(
  loader: () => Promise<T>,
  exportName: keyof T = "default" as keyof T
) {
  return lazyRouteComponent(() =>
    loader().then((mod) => ({
      // eslint-disable-next-line security/detect-object-injection
      default: mod[exportName],
    }))
  )
}
